import type { ErrorMap } from '@/app/error-registry';

export const ACCEPT_INVITATION_ERROR_MAP: ErrorMap = {
  POST: {
    conflict: 'invitations:apiErrors.acceptConflict',
    notFound: 'invitations:apiErrors.acceptNotFound',
    default: 'invitations:apiErrors.acceptDefault',
  },
};

export const REJECT_INVITATION_ERROR_MAP: ErrorMap = {
  POST: {
    conflict: 'invitations:apiErrors.rejectConflict',
    notFound: 'invitations:apiErrors.rejectNotFound',
    default: 'invitations:apiErrors.rejectDefault',
  },
};
